module.exports = __webpack_public_path__ + "static/media/PB_G_05.cadd8bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_05.png
// module id = 218
// module chunks = 0